import { render } from "./ToolboxSave.vue?vue&type=template&id=0ac584cb"
import script from "./ToolboxSave.vue?vue&type=script&lang=js"
export * from "./ToolboxSave.vue?vue&type=script&lang=js"

import "./ToolboxSave.vue?vue&type=style&index=0&id=0ac584cb&lang=scss"

import exportComponent from "/app/tmp/bambl/V3/v2026.25.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__